/**
 * Stat Animations
 * - Count-up animation for number stats (data-stat-count)
 * - Letter-by-letter fade reveal for text stats (data-stat-reveal)
 * - Legacy support for data-countdown-reverse
 */

(function () {
    const DURATION = 1500;
    const STAGGER = 75;
    const INTERVAL = 16;

    /* ─── Number count-up ─── */
    function countUp(el, target, delay) {
        const steps = Math.ceil(DURATION / INTERVAL);
        const stepSize = target / steps;
        let current = 0;

        setTimeout(() => {
            const interval = setInterval(() => {
                current += stepSize;
                if (current >= target) {
                    el.textContent = parseInt(target, 10).toLocaleString();
                    clearInterval(interval);
                } else {
                    el.textContent = Math.round(current).toLocaleString();
                }
            }, INTERVAL);
        }, delay);
    }

    /* ─── Letter-by-letter fade reveal ─── */
    /* Wraps each word in an inline-flex span to prevent mid-word breaks */
    function letterReveal(el, finalText, delay) {
        const words = finalText.split(' ');
        let totalChars = finalText.replace(/\s/g, '').length;
        const perLetterDelay = DURATION / totalChars;

        /* Build HTML: each word is a nowrap container, each letter is an opacity-0 span */
        let html = words.map(function(word) {
            let wordHtml = '<span style="display:inline-flex;white-space:nowrap">';
            for (let i = 0; i < word.length; i++) {
                wordHtml += '<span style="opacity:0;transition:opacity 0.3s ease-in-out">' + word[i] + '</span>';
            }
            wordHtml += '</span>';
            return wordHtml;
        }).join(' ');

        el.innerHTML = html;

        /* Fade in each letter sequentially */
        setTimeout(() => {
            const letterSpans = el.querySelectorAll('span > span');
            letterSpans.forEach((span, i) => {
                setTimeout(() => {
                    span.style.opacity = '1';
                }, i * perLetterDelay);
            });
        }, delay);
    }

    /* ─── Stats panel observer (new panels) ─── */
    function initStatsAnimations() {
        const panels = document.querySelectorAll('.stats-panel');

        panels.forEach((panel) => {
            let animated = false;

            const observer = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting && !animated) {
                    animated = true;
                    observer.unobserve(panel);

                    const allStats = panel.querySelectorAll('[data-stat-count], [data-stat-reveal]');
                    allStats.forEach((el, i) => {
                        if (el.dataset.statCount !== undefined) {
                            countUp(el, parseFloat(el.dataset.statCount), i * STAGGER);
                        } else if (el.dataset.statReveal !== undefined) {
                            letterReveal(el, el.dataset.statReveal, i * STAGGER);
                        }
                    });
                }
            }, { threshold: 0.2 });

            observer.observe(panel);
        });
    }

    /* ─── Legacy support for data-countdown-reverse ─── */
    function initLegacyCountdowns() {
        const items = document.querySelectorAll('[data-countdown-reverse]');

        items.forEach((el) => {
            const observer = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting && entries[0].intersectionRatio === 1) {
                    setTimeout(() => {
                        countUp(el, parseFloat(el.dataset.countdownReverse), 0);
                    }, 150);
                    observer.unobserve(el);
                }
            }, { threshold: 1 });

            observer.observe(el);
        });
    }

    /* ─── Init ─── */
    window.addEventListener('load', () => {
        initStatsAnimations();
        initLegacyCountdowns();
    });
})();
